import { render, staticRenderFns } from "./DriverChat.vue?vue&type=template&id=7c1bd736&"
import script from "./DriverChat.vue?vue&type=script&lang=js&"
export * from "./DriverChat.vue?vue&type=script&lang=js&"
import style0 from "./DriverChat.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports